// TOP LEVEL IMPORTS
import React from 'react';
// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
// ANTD
// ANTD

import Select, { Option } from 'antd/lib/select';

// CONSTANTS AND DESTRUCTURING
// ================================================================

const CLIENT_STATUS = ['Lead', 'Client'];

// EXPORTED COMPONENT
// ================================================================
const ClientStatusInput = props => (
  <Select
    {...props}
    size="large"
    showSearch
    optionFilterProp="children"
    filterOption={GeneralHelpers.selectSearchFilter}
  >
    {CLIENT_STATUS.map(item => (
      <Option key={item} value={item}>
        {item}
      </Option>
    ))}
  </Select>
);

// EXPORT
// ================================================================
export default ClientStatusInput;



// WEBPACK FOOTER //
// ./src/components/inputs/ClientStatusInput/index.js